<template>
  <!--begin::General Widget 1-->
  <v-container class="mb-10">
    <div class="">
      <div class="card-header border-0">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label page-title fw-bolder fs-3 mb-1"
            >Manage Categories</span
          >
          <!-- <span class="text-muted mt-1 fw-bold fs-7">Active Barrels</span> -->
        </h3>
      </div>
    </div>

    <div class="spacer-y-10"></div>

    <div class="card">
      <div class="card-body py-10">
        <div class="tab-content">
          <!--begin::Tap pane-->
          <div class="tab-pane fade show active" id="kt_table_widget_5_tab_1">
            <div class="fv-row mb-10 fv-plugins-icon-container">
              <!--begin::Label-->
              <label class="d-flex align-items-center fs-5 fw-bold mb-2">
                <span class="required">Upload csv</span>
                <i
                  class="fas fa-exclamation-circle ms-2 fs-7"
                  data-bs-toggle="tooltip"
                  v-b-tooltip.hover
                  title=""
                  data-bs-original-title="Specify your unique app name"
                  aria-label="Specify your unique app name"
                ></i>
              </label>
              <!--end::Label-->
              <!--begin::Input-->
              <input
                type="file"
                class="form-control form-control-lg form-control-solid"
                name="name"
                accept=".csv"
                @change="readFile"
              />
              <!--end::Input-->
              <div class="fv-plugins-message-container invalid-feedback"></div>
            </div>

            <!-- <div class="separator my-2 mb-10"></div> -->

            <div class="d-flex align-items-center mb-10">
              <div class="border-bottom border-gray-300 mw-50 w-100"></div>
              <span class="fw-bold text-gray-400 fs-7 mx-2">OR</span>
              <div class="border-bottom border-gray-300 mw-50 w-100"></div>
            </div>

            <span class="fw-bolder text-dark mt-7">Add Category</span>

            <div class="fv-row mt-8 mb-10 fv-plugins-icon-container">
              <!--begin::Label-->
              <label class="d-flex align-items-center fs-5 fw-bold mb-2">
                <span class="required">Category Name</span>
                <i
                  class="fas fa-exclamation-circle ms-2 fs-7"
                  data-bs-toggle="tooltip"
                  v-b-tooltip.hover
                  title="name describing category"
                ></i>
              </label>
              <!--end::Label-->
              <!--begin::Input-->
              <input
                type="text"
                class="form-control form-control-lg form-control-solid"
                v-model="newCategories"
              />
              <!--end::Input-->
              <div class="fv-plugins-message-container invalid-feedback"></div>
            </div>

            <button
              @click="addCategoryConfirmation"
              :class="addCategoryBtnClass"
              data-bs-toggle="modal"
              data-bs-target="#kt_modal_confirm"
            >
              Add Category
              <span
                v-if="loading"
                class="spinner-border spinner-border-md align-middle ms-2"
              ></span>
              <svg
                v-if="!loading"
                width="22"
                height="23"
                viewBox="0 0 22 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.9775 21.5121C16.4009 21.5121 20.7975 17.1156 20.7975 11.6921C20.7975 6.26869 16.4009 1.87213 10.9775 1.87213C5.55403 1.87213 1.15747 6.26869 1.15747 11.6921C1.15747 17.1156 5.55403 21.5121 10.9775 21.5121Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M10.9775 15.6201L14.9055 11.6921L10.9775 7.7641"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M7.04956 11.6921H14.9056"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>

            <div class="spacer-y-10"></div>
            <div class="spacer-y-10"></div>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-data-table
              :headers="tableHeaders"
              :items="categories"
              :search="search"
              item-key="Id"
              class="elevation-1"
              :loading="loadingCategories"
              loading-text="Loading Categories"
            >
              <template v-slot:[`item.ICName`]="{ item }">
                <CategoryChip :category="item" @edited="getCategories" />
              </template>
            </v-data-table>
          </div>
        </div>
        <ConfirmationModal
          :isLoadingConfirmation="loadingConfirmation"
          :isShowDialog="isShowConfirmationModal"
          :btnConfig="buttonConfiguration"
          :inputInfo="confirmationModalInfo"
          :inputColor="confirmationModalInfoColor"
          @eConfirm="addCategories"
          @eCancel="defaultCancelOperation"
        />
        <SnackbarNotifier
          :isShow="isShowSnackBar"
          :message="responseMessage"
          :snackType="snackbarType"
          :colour="snackBarColour"
          @eReset="resetSnackBar"
        />
      </div>
      <!--end::Body-->
    </div>
  </v-container>
  <!--end::General Widget 1-->
</template>
<script>
import { ApiService } from "@/services/ApiService";
import CategoryChip from "@/components/CategoryChip.vue";
import { error } from "@/services/LoggerService";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import mixins from "vue-typed-mixins";

export default mixins(SnackbarNotifierMixin, ConfirmationModalMixin).extend({
  name: "ManageCategories",
  data() {
    return {
      loadingCategories: false,
      loading: false,
      newCategories: "",
      categories: [],
      search: "",
      tableHeaders: [{ text: "Category", value: "ICName" }],
    };
  },
  components: {
    CategoryChip,
    ConfirmationModal,
    SnackbarNotifier,
  },
  computed: {
    addCategoryBtnClass() {
      const defaultClass = "btn fw-bold px-6 py-5 w-100 mb-4 mt-6";
      if (!this.newCategories || this.loading)
        return `${defaultClass} btn-secondary disabled`;
      return `${defaultClass} btn-primary`;
    },
  },
  methods: {
    removeDuplicates() {
      try {
        let newCat = this.newCategories.split(",").map((s) => s.trim());
        let oldCat = [];
        let temp = [];
        this.categories.forEach(function (c) {
          oldCat.push(c.ICName.trim().toUpperCase());
        });
        newCat.forEach(function (c) {
          if (!oldCat.includes(c.toUpperCase())) temp.push(c);
        });
        return temp;
      } catch (e) {
        error(e);
      }
    },
    addCategoryConfirmation() {
      this.showConfirmationModal({
        title: "Add New Category",
        message: `Are you sure you want to add <b><em>${this.newCategories}</em></b>?`,
      });
    },
    async addCategories() {
      try {
        this.startConfirmationLoading();
        let items = this.removeDuplicates();
        if (!items.length) {
          this.stopConfirmationLoading();
          this.showNotifier({
            message: `${this.newCategories} Is Already A Category`,
            snackbarType: "info",
          });
          this.newCategories = "";
          return;
        }
        var result = await ApiService.Instance.addItemCategories(items);

        if (result) {
          await this.getCategories();
          this.showNotifier({
            message: `Successfully Add ${this.newCategories}`,
            snackbarType: "success",
          });
          this.newCategories = "";
        }
        this.stopConfirmationLoading();
      } catch (e) {
        this.showNotifier({
          message: `Failed To Add`,
          snackbarType: "error",
        });
        this.stopConfirmationLoading();
        error(e);
      }
    },
    async getCategories() {
      try {
        this.loadingCategories = true;
        this.categories = await ApiService.Instance.getItemCategories();
        this.loadingCategories = false;
      } catch (e) {
        this.loadingCategories = false;
        error(e);
      }
    },
    readFile(e) {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => (this.newCategories = e.target.result);
        reader.readAsText(file);
      }
    },
  },
  async beforeMount() {
    try {
      await this.getCategories();
    } catch (e) {
      error(e);
    }
  },
});
</script>
